import { useQuery } from '@tanstack/react-query';
import { getDownloadTemplateOpportunity } from 'services/api/requests/uploads/uploads';

export const useDownloadTemplateOpportunity = () => {
	return useQuery(
		['download-template-opportunity'],
		getDownloadTemplateOpportunity,
		{
			refetchOnWindowFocus: false,
			enabled: false,
		}
	);
};
